import { useEffect, useState } from 'react';
import { GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import {
  getDefaultPreferences,
  getPreferencesByKey,
  getUserPreferencesSubject,
  GridPreferences
} from '../../../store/User';
import { UpstackDataGrid } from '../UpstackDataGrid/UpstackDataGrid';
import { getTagLoadingSubject, getTagSubject, Tag } from '../../../store/Tags';
import { DefaultTagGridColumnDefs } from './TagsGridColumnDefs';
import { getGridColumns } from '../UpstackDataGrid/helpers';
import { PageCard } from '../CardWithTitle';
import { AddTagForm } from './AddTagForm';

export interface TagsTableProps {
  accountId?: string;
}

export const TagsTable = ({ accountId }: TagsTableProps) => {
  const [tags, setTags] = useState<Tag[]>([]);
  const [tagsLoading, setTagsLoading] = useState<boolean>(false);
  const [tagColumns, setTagColumns] = useState<GridSingleSelectColDef[]>();
  const [gridSettings, setGridSettings] = useState<GridPreferences>(
    getDefaultPreferences().content['tag_grid'] as GridPreferences
  );

  useEffect(() => {
    const subscription = getTagSubject().subscribe((tags) => {
      setTags(tags);
      setTagColumns(getGridColumns(tags, DefaultTagGridColumnDefs, 'tag_grid'));
    });
    const settingsSub = getUserPreferencesSubject().subscribe(() => {
      const gridPrefs = getPreferencesByKey('tag_grid') as GridPreferences;
      if (gridPrefs) {
        setGridSettings(gridPrefs);
      }
    });
    const loadingSubscription = getTagLoadingSubject().subscribe((loading) => setTagsLoading(loading));

    return () => {
      if (subscription) subscription.unsubscribe();
      if (loadingSubscription) loadingSubscription.unsubscribe();
      if (settingsSub) settingsSub.unsubscribe();
    };
  }, []);

  const cardActions = () => (accountId && !tagsLoading ? <AddTagForm accountId={accountId} /> : <></>);
  return (
    <div>
      <PageCard
        title="Tags"
        cardActions={cardActions()}
        collapsed={tags.length === 0 && !tagsLoading}>
        <UpstackDataGrid
          dataCy="tags-data-grid"
          title="Tags"
          rows={accountId ? tags : []}
          columns={tagColumns}
          loadingData={tagsLoading}
          page="tag_grid"
          gridSettings={gridSettings}
          pinnedColumns={{ right: ['actions'] }}
          showSearch={true}
        />
      </PageCard>
    </div>
  );
};
